import type { FaireProductEntity } from "../../entity_types/product";

export const p_cbxffph3v9: FaireProductEntity = {
  token: "p_cbxffph3v9",
  type: "product",
  name: "Chirps and Cheers Recipe Card Set",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/ae7a2fb2667248e9505c37c74df8996a212ace019b2b78393a9e91d3e83c2821.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/82ce0f3852df487a9c34aba99d034e4790b8762cfc9c9103a31db3c0b3961f2b.jpeg",
    "https://cdn.faire.com/fastly/0702fd8e48138300110c35f97654ebd3c4bcca4be38e217c1b43a726106f7b94.jpeg",
  ],
  priceDollars: 7,
  description:
    "Let's go old school and trade recipes! A hand-written recipe card creates memories, legacies, even! Generations to come will know what yumminess you experienced, and what handwriting used to look like!\n\nSet of 12 recipe cards",
  tags: [],
  msrpDollars: 14,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:35:44.240Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
